import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  locationsToAdd: []
};

export const addLocationsSlice = createSlice({
  name: 'addLocationsSlice',
  initialState,
  reducers: {
    addLocations: (state, action) => {
        state.locationsToAdd = action.payload;
    }
  }
});

export const {
    addLocations
} = addLocationsSlice.actions;

export default addLocationsSlice.reducer;